import * as Yup from 'yup';
import { Formik } from 'formik';
import React, { Fragment } from 'react';
import moment from 'moment';
import { ModalComponent } from 'components/layout/modals/ModalComponent';
import { ApplicantDropdown } from 'components/layout/form-fields/inputs/ApplicantDropdown';
import { applicantStore } from '../ApplicantStore';
import './MigratePublicProfileModal.sass';

const ValidationSchema = Yup.object().shape({
	selectedApplicant: Yup.object().nullable().required().label('Candidate'),
	acknowledged: Yup.boolean()
		.oneOf([true], 'You must acknowledge this action')
		.required()
});

export default class MigratePublicProfileModal extends ModalComponent {
	getInitialValues() {
		return {
			selectedApplicant: null,
			acknowledged: false
		};
	}

	render() {
		return (
			<Formik
				initialValues={this.getInitialValues()}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.migrate(values);
				}}>
				{formikProps =>
					this.renderModalContainer(formikProps, 'MigratePublicProfileModal')
				}
			</Formik>
		);
	}

	formatCreatedOn(date) {
		return date ? moment(date).format('ll') : '—';
	}

	renderForm(formikProps) {
		const { applicant } = this.props;
		const { selectedApplicant, acknowledged } = formikProps.values;

		return (
			<Fragment>
				<div className="columns">
					<div className="column is-full">
						<div className="field has-text-left">
							<label className="subtitle is-7">Candidate</label>
							<div className="control">
								<ApplicantDropdown
									placeholder="Select a Candidate with a Public Profile"
									value={selectedApplicant}
									hasPublicProfile
									excludeApplicantId={applicant?.id}
									showAvatar
									showId
									onValueChange={item => {
										formikProps.setFieldValue('selectedApplicant', item);
										formikProps.setFieldValue('acknowledged', false);
									}}
								/>
							</div>
						</div>

						{selectedApplicant && (
							<div className="migrate-disclaimer has-text-left">
								<label className="migrate-disclaimer-label">
									<input
										type="checkbox"
										checked={acknowledged}
										onChange={e => {
											formikProps.setFieldValue(
												'acknowledged',
												e.target.checked
											);
										}}
									/>
									<span>
										I understand this action will migrate the Public Profile
										from Candidate <strong>{selectedApplicant.name}</strong>{' '}
										Created On{' '}
										<strong>
											{this.formatCreatedOn(selectedApplicant.createdAt)}
										</strong>{' '}
										to Candidate <strong>{applicant?.name}</strong> Created On{' '}
										<strong>
											{this.formatCreatedOn(applicant?.createdAt)}
										</strong>
										.
									</span>
								</label>
							</div>
						)}
					</div>
				</div>
			</Fragment>
		);
	}

	async migrate(values) {
		const candidateId =
			values.selectedApplicant?.candidateId ||
			values.selectedApplicant?.candidate?.id;

		if (!candidateId) {
			this.resultNotification(
				{ status: 'fail' },
				'Public Profile',
				'Migrate',
				'Migrate Public Profile',
				'The selected Candidate does not have a Public Profile.'
			);
			return;
		}

		const result = await applicantStore.assignCandidate({
			applicantId: this.props.applicant.id,
			candidateId
		});

		this.resultNotification(
			result,
			'Public Profile',
			'Migrate',
			'Migrate Public Profile',
			'The Public Profile has been migrated successfully.'
		);
	}
}
